import {
  AppStateAPI, AudioAPI, AudioDeviceAPI,
  JsAudioDevice,
  MessagesAPI, PortWindowMessage,
} from './dualChannelTypes';

// eslint-disable-next-line import/prefer-default-export
export const IPC_AUDIO_DEVICE_CHANNELS = {
  LIST_INPUT_DEVICES: 'audio-device:list-input-devices',
  LIST_OUTPUT_DEVICES: 'audio-device:list-output-devices',
  SUBSCRIBE_TO_CHANGES: 'audio-device:subscribe-to-changes',
};

if (window.appStateBridge) {
  const appStateAPI: AppStateAPI = {
    ...window.appStateBridge,
    subscribeToStateChanges(key: string) {
      const { port1, port2 } = new MessageChannel();
      const message: PortWindowMessage = {
        type: 'ipc-port',
        ipcChannel: 'state-connect:subscribe',
        args: { key },
      };
      window.postMessage(message, '*', [port2]);
      return port1;
    },
  };
  window.appStateAPI = appStateAPI;
}

if (window.electronMessagingBridge) {
  const electronMessagingApi: MessagesAPI = {
    ...window.electronMessagingBridge,
    subscribeToMessageChannel(key: string) {
      const { port1, port2 } = new MessageChannel();
      const message: PortWindowMessage = {
        type: 'ipc-port',
        ipcChannel: 'messages:subscribe-to-message-channel',
        args: key,
      };
      window.postMessage(message, '*', [port2]);
      return port1;
    },
  };
  window.electronMessagingApi = electronMessagingApi;
}

if (window.audioDeviceBridge) {
  const audioDeviceAPI: AudioDeviceAPI = {
    ...window.audioDeviceBridge,
    subscribeToChanges() {
      const { port1, port2 } = new MessageChannel();
      const message: PortWindowMessage = {
        type: 'ipc-port',
        ipcChannel: IPC_AUDIO_DEVICE_CHANNELS.SUBSCRIBE_TO_CHANGES,
      };
      window.postMessage(message, '*', [port2]);
      return port1;
    },
  };

  window.audioDeviceAPI = audioDeviceAPI;
}

if (window.audioBridge) {
  const audioAPI: AudioAPI = {
    ...window.audioBridge,
    startStreaming(device: JsAudioDevice) {
      const { port1, port2 } = new MessageChannel();
      const message: PortWindowMessage = {
        type: 'ipc-port',
        ipcChannel: 'audio:start',
        args: device,
      };
      window.postMessage(message, '*', [port2]);
      return port1;
    },
  };
  window.audioAPI = audioAPI;
}

if (window.electronNotificationBridge) {
  window.electronNotificationAPI = window.electronNotificationBridge;
}
